@use '@fpsm/cxy-scss' as cxy;

.distanceRefinementContainer {
  @include cxy.stack(var(--cxy-spacing-xsm));
  margin-top: var(--distance-refinement-margin-top, var(--cxy-spacing-xxsm));
}

.distanceRefinementItems {
  @include cxy.stack(var(--cxy-spacing-xsm));
}

.resetButton {
  align-self: center;
}
